import { render, staticRenderFns } from "./DomainDistribution.vue?vue&type=template&id=f23402e6&scoped=true"
import script from "./DomainDistribution.vue?vue&type=script&lang=js"
export * from "./DomainDistribution.vue?vue&type=script&lang=js"
import style0 from "./DomainDistribution.vue?vue&type=style&index=0&id=f23402e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23402e6",
  null
  
)

export default component.exports